import type { ViewMode } from './types'

export function shouldUseRequireJs(viewMode: ViewMode, dmServerNoRequireJs?: boolean): boolean {
	return viewMode === 'Site' || !dmServerNoRequireJs
}
